import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faMapLocationDot, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';
import { Navbar } from '../../components';
import ToDoList from '../../components/todo-list';
import TravelMap from './travel-map';
import Weather from './weather';
import '../../styling/dashboard.scss';
import ListView from './listview';
import { API_URL } from '../../constants';

function TripDetail() {
  const { tripId } = useParams();

  const [view, setView] = useState('map');
  const [tripData, setTripData] = useState(null);
  const [userSelection, setUserSelection] = useState(null);
  const [location, setLocation] = useState(null);
  const [numDays, setNumDays] = useState(null);
  const [loading, setLoading] = useState(true);
  const [daysDifference, setDaysDifference] = useState(null);
  const [tripStatus, setTripStatus] = useState(null);
  const [locationId, setLocationId] = useState(null);
  const [showComponentsOverlay, setShowComponentsOverlay] = useState(false);

  useEffect(() => {
    const fetchTripById = async () => {
      try {
        const response = await fetch(`${API_URL}/api/trips/fetch-by-id/${tripId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch trip details');
        }
        const trip = await response.json();
        setTripData(trip.tripData); // Update tripData
        setUserSelection(trip.userSelection); // Update tripData
        setNumDays(trip.tripData.n_days);
        setLocation(trip.userSelection?.location?.label || ''); // Update location
        setLocationId(trip.userSelection?.location?.place_id);
        if (trip.userSelection.startDate && trip.userSelection.endDate) {
          const startDate = new Date(trip.userSelection.startDate);
          const endDate = new Date(trip.userSelection.endDate);
          const today = new Date();

          const startDateUTC = new Date(Date.UTC(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate()));
          const endDateUTC = new Date(Date.UTC(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate()));
          const todayUTC = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()));

          if (todayUTC < startDateUTC) {
            setDaysDifference(Math.floor((startDateUTC - todayUTC) / (1000 * 60 * 60 * 24)));
            setTripStatus('until'); // "X days until trip"
          } else if (todayUTC > endDateUTC) {
            setDaysDifference(Math.floor((todayUTC - endDateUTC) / (1000 * 60 * 60 * 24)));
            setTripStatus('since');
          } else {
            setDaysDifference(0);
            setTripStatus('ongoing'); // "Trip is ongoing"
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchTripById();
  }, [tripId]);

  const renderView = () => {
    switch (view) {
      case 'map':
        if (tripData) {
          return <TravelMap itinerary={tripData.things_to_do} dining={tripData.dining_options} lodging={tripData.lodging_options} style={{ flex: '1', width: '100%', height: '100%' }} />;
        } else {
          return <TravelMap style={{ flex: '1', width: '100%', height: '100%' }} />;
        }
      case 'list':
        if (tripData) {
          return <ListView itinerary={tripData.things_to_do} lodging={tripData.lodging_options} dining={tripData.dining_options} style={{ flex: '1', width: '100%', height: '100%' }} />;
        } else {
          return <ListView style={{ flex: '1', width: '100%', height: '100%' }} />;
        }
      default:
        return <div>No view selected</div>;
    }
  };

  return (
    <div style={{
      display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '100vh', overflow: 'hidden',
    }}
    >
      <div className="navbar" style={{ height: '100%', flex: '0 0 auto' }}>
        <Navbar />
      </div>

      <div className="info-board">
        <div className="tripInfo">
          <div className="topbar">
            <div className="trip-name"> {location}</div>
          </div>
          {/* new stuff start here */}
          <div className="info-blocks">
            <div className="summary-section">
              <div className="countdown">
                <h2>Countdown</h2>
                <div className="days">{daysDifference}</div>
                <h3>
                  {tripStatus === 'until' && 'Days to Trip'}
                  {tripStatus === 'since' && 'Days since Trip'}
                  {tripStatus === 'ongoing' && 'Trip is Ongoing'}
                </h3>
              </div>
              <div className="weather">
                {locationId ? (
                  <Weather locationId={locationId} />
                ) : (
                  <p>Loading weather...</p>
                )}
              </div>
            </div>

            {/* Overlay */}
            {showComponentsOverlay && (
              <div className="overlay">
                <div className="overlay-content">
                  <p>More components to come later!</p>
                  <button className="close-btn" onClick={() => setShowComponentsOverlay(false)}>
                    Close
                  </button>
                </div>
              </div>
            )}

            <button className="more-info-btn" onClick={() => setShowComponentsOverlay(true)}>
              <FontAwesomeIcon icon={faPlus} className="plus-icon" />
              More Components
            </button>

            {/* To-Do Placeholder */}
            <div className="todo-placeholder">
              <ToDoList />
            </div>
          </div>
          {/* new stuff ends here */}
        </div>
      </div>

      <div className="views" style={{ height: '100%', flex: '1' }}>
        {
          // view === 'map' ? (
          //   <TravelMap style={{ flex: '1', width: '100%', height: '100%' }} />
          // ) : view === 'list' ? (
          //   <ListView itinerary={tripData.itinerary} style={{ flex: '1', width: '100%', height: '100%' }} />
          // ) : view === 'calendar' ? (
          //   <div style={{ flex: '1', width: '100%' }}>
          //     HI
          //   </div>
          // ) : (
          //   <div>No view selected</div>
          // )
          renderView()
        }
      </div>

      <div className="view-buttons">
        <button onClick={() => setView('map')} className="view-button">
          <FontAwesomeIcon icon={faMapLocationDot} className="icon" />
          Map View
        </button>
        <button onClick={() => setView('list')} className="view-button">
          <FontAwesomeIcon icon={faList} className="icon" />
          List View
        </button>
      </div>
    </div>
  );
}

export default TripDetail;
